import {AfterViewInit, Component,  ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription} from "rxjs";
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MaterialInstance, MaterialService} from "../shared/classes/material.service";
import {StreamsService}  from "../shared/services/streams.service";
import {StreamProject} from "../shared/interfaces";
import {switchMap, map, delay} from 'rxjs/operators';
import { Socket } from 'ngx-socket-io';
import {SocketStreamsControl, socketEvents} from '../shared/services/sockets'
import {VideoPlayerComponent} from '../shared/components/video-player/video-player.component'

///getToken 
//streaming

@Component({
  selector: 'app-stream-page',
  templateUrl: './stream-page.component.html',
  styleUrls: ['./stream-page.component.scss'],
})
export class StreamPageComponent implements OnInit, OnDestroy{


  @ViewChild('video') videoComponent:VideoPlayerComponent 


  mode = {
    overview: 1,
    settings: 2
  }

  currentMode: number 

  stream: StreamProject
 stream$:Observable<StreamProject>
  



   constructor(
    public streamsService: StreamsService,
    public route:  ActivatedRoute  ){
      this.currentMode = this.mode.overview
   }

  ngOnInit() { 
   

    this.stream$ = this.route.params.pipe(
      switchMap((params: Params)=>{
        
        return this.streamsService.getById(params['id']).pipe(
          map((stream: any)=>{

            
            this.stream = stream
            return stream
          })
        )
      })
    )
 
  }


  setMode(mode){

    if(this.currentMode !== mode){
      this.currentMode = mode
    }
  }
   
   ngOnDestroy() { 
 
    
   }
 
   
  
}
